import { useContext, useEffect, useRef, useState } from "react";
import { getTranslate } from "react-localize-redux";
import { useSelector } from "react-redux";

import { MainContext } from "@context";

const selectTranslate = (state) => ({
	translate: getTranslate(state.localize),
});

const useController = ({
	value,
	items,
	onSelect,
	onClose,
	isProvidersFilter,
	initialSelectedItem,
}) => {
	const headerRef = useRef(null);
	const searchRef = useRef(null);

	const { translate } = useSelector(selectTranslate);

	const { state: contextState } = useContext(MainContext);

	const [open, setOpen] = useState(false);
	const [isSearchOpen, setIsSearchOpen] = useState(false);
	const [selectedItem, setSelectedItem] = useState(null);
	const [searchTerm, setSearchTerm] = useState("");

	useEffect(() => {
		const handleKeyDown = (e) => {
			if (e.key === "Escape") {
				setOpen(false);
				setSearchTerm("");
				setIsSearchOpen(false);
			}
		};

		const handleClick = (e) => {
			if (isProvidersFilter) {
				if (
					headerRef?.current &&
					!headerRef.current.contains(e.target) &&
					searchRef?.current &&
					!searchRef.current.contains(e.target)
				) {
					setOpen(false);
				}
			} else {
				if (headerRef?.current && !headerRef.current.contains(e.target)) {
					setOpen(false);
				}
			}
		};

		if (open) {
			window.addEventListener("keydown", handleKeyDown);
			document.addEventListener("mouseup", handleClick);
		} else {
			window.removeEventListener("keydown", handleKeyDown);
			document.removeEventListener("mouseup", handleClick);
		}

		onClose?.(open);

		return () => {
			window.removeEventListener("keydown", handleKeyDown);
			document.removeEventListener("mouseup", handleClick);
		};
	}, [open]);

	useEffect(() => {
		if (!value) {
			setSelectedItem(initialSelectedItem || null);
		}
	}, [value]);

	useEffect(() => {
		if (initialSelectedItem) {
			const selectedItem = items.find((item) => item.key === initialSelectedItem.key);
			setSelectedItem(selectedItem);
		}
	}, [initialSelectedItem]);

	const handleSelect = (item) => {
		setOpen(false);
		onSelect?.(item);
		setSelectedItem(item);
	};

	const handleClearSearchInput = () => {
		setSearchTerm("");
	};

	const handleToggle = () => {
		setOpen((prev) => !prev);
	};

	return {
		refs: { headerRef, searchRef },
		helpers: { translate },
		state: {
			...contextState,
			open,
			isSearchOpen,
			selectedItem,
			searchTerm,
			filteredItems: items?.filter((item) =>
				item.value.toLowerCase().includes(searchTerm.toLowerCase())
			),
		},
		handlers: {
			handleToggle,
			handleSelect,
			handleClearSearchInput,
			setIsSearchOpen,
			setSearchTerm,
		},
	};
};

export default useController;
